<!-- Lista de Posts Component -->
<div class="space-y-4 py-3">
  <!-- Loading skeleton -->
  <div *ngIf="isLoading" class="space-y-3">
    <div
      *ngFor="let item of [1, 2, 3]"
      class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 animate-pulse"
    >
      <div class="flex items-center space-x-3 mb-4">
        <div class="w-12 h-12 bg-gray-200 rounded-full"></div>
        <div class="space-y-2 flex-1">
          <div class="h-4 bg-gray-200 rounded w-1/4"></div>
          <div class="h-3 bg-gray-200 rounded w-1/6"></div>
        </div>
      </div>
      <div class="space-y-3">
        <div class="h-4 bg-gray-200 rounded w-full"></div>
        <div class="h-4 bg-gray-200 rounded w-3/4"></div>
        <div class="h-4 bg-gray-200 rounded w-1/2"></div>
      </div>
    </div>
  </div>

  <!-- Posts list -->
  <div *ngIf="!isLoading && posts.length > 0" class="space-y-3">
    <div
      *ngFor="let post of posts; trackBy: trackByPostId"
      class="post-item transition-all duration-200"
    >
      <app-feed-post
        [post]="post"
        [showActions]="showActions"
        [currentUserId]="currentUserId"
        (toggleLike)="onToggleLike($event)"
        (deletePost)="onDeletePost($event)"
        (sharePost)="onSharePost($event)"
        (viewProfile)="onViewProfile($event)"
        (votePoll)="onVotePoll($event)"
        (editPost)="onEditPost($event)"
      >
      </app-feed-post>
    </div>
  </div>

  <!-- Empty state -->
  <div
    *ngIf="showEmptyState && !isLoading && posts.length === 0"
    class="bg-white rounded-lg shadow-sm border border-gray-200 p-12 text-center"
  >
    <div class="w-24 h-24 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center">
      <i class="fas fa-comments text-4xl text-gray-400"></i>
    </div>

    <h3 class="text-xl font-semibold text-gray-800 mb-2">{{ emptyMessage }}</h3>
    <p class="text-gray-500 mb-6">Aún no hay publicaciones para mostrar.</p>

    <div class="text-sm text-gray-400">¡Sé el primero en compartir algo interesante!</div>
  </div>
</div>
